<template>
  <div>
    <title>收付款记录</title>
    <section class="mainPart">
      <!--S 头部tab-->
      <CompanyTab :active="currentTit"></CompanyTab>
      <!--E 头部tab-->

      <!--S 收付款记录组件-->
      <PayReceivedRecord :payReceivedType="1"></PayReceivedRecord><!--:payReceivedType="1"-->
      <!--E 收付款记录组件-->
    </section>

  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
export default {
  name: 'PaymentReceivedRecord',
  data () {
    return {
     currentTit:3,
     payReceivedType:1,//收付款来源， 0:订单详情中的收付款记录 1：总的收付款记录
    }
  },
  components: {
    CompanyTab: resolve => require(["@/components/ManageFolder/CompanyTab.vue"],resolve), //头部tab组件
    PayReceivedRecord: resolve => require(["@/components/OrderFolder/StoreSale/PayReceivedRecord.vue"], resolve),//收付款记录组件
  },
  watch: {
  },
  methods: {
    
  },
  created() {

  },
  mounted (){

  },
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
</style>



// WEBPACK FOOTER //
// src/views/OrderFolder/StoreSale/PayReceivedRecord.vue